import { render, staticRenderFns } from "./contactList.vue?vue&type=template&id=01278fa0&scoped=true&"
import script from "./contactList.vue?vue&type=script&lang=js&"
export * from "./contactList.vue?vue&type=script&lang=js&"
import style0 from "./contactList.vue?vue&type=style&index=0&id=01278fa0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01278fa0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01278fa0')) {
      api.createRecord('01278fa0', component.options)
    } else {
      api.reload('01278fa0', component.options)
    }
    module.hot.accept("./contactList.vue?vue&type=template&id=01278fa0&scoped=true&", function () {
      api.rerender('01278fa0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/components/contactList.vue"
export default component.exports